import {Stack, VisuallyHidden, Text} from '@treatwell/ui';
import styles from './AppointmentBasket.module.css';
import {Marketplace} from '../Marketplace';
import {Basket} from './Basket';
import {Divider} from './Divider';
import {useAppSelector} from '../../hooks/store';
import {selectSkus} from '../../store/slices/selectors';
import {OrderListContainer} from '../OrderList/OrderList';
import {OrderTotalContainer} from '../OrderTotal/OrderTotal';
import {useTranslation} from 'react-i18next';
import {RouteAvailability} from '../Router';
import {AddServiceLink} from '../AddServiceLink';
import {selectVenueData} from '../../store/slices/venue/slice';
import {RescheduleOrderSubmitContainer} from '../Submit';
import {RouteReschedule} from '../Router/Router';
import {OrderDateContainer} from '../OrderDate/OrderDateContainer';
import {DepositContainer} from '../Deposit/Deposit';

export const AppointmentBasket = () => {
  const venueData = useAppSelector(selectVenueData);
  const skus = useAppSelector(selectSkus);
  const {t} = useTranslation();
  const addServiceLinkText = t('calendar.addAnotherService');

  return (
    <Basket>
      <Stack space="2xl">
        <Marketplace>
          <Text as="h3" type="mdHeader" className={styles.venueName}>
            {venueData.name}
          </Text>
        </Marketplace>
        <RouteReschedule>
          <OrderDateContainer />
        </RouteReschedule>
        <Stack space="lg">
          <div>
            <VisuallyHidden as="h3">
              {t<string>('order.itemTotalTitle', {
                count: Object.keys(skus).length,
              })}
            </VisuallyHidden>
            <OrderListContainer />
          </div>
          <RouteAvailability>
            <AddServiceLink url={venueData.uri} text={addServiceLinkText} />
          </RouteAvailability>
          <RouteReschedule>
            <>
              <Divider />
              <Stack space="lg">
                <DepositContainer />
                <Stack>
                  <OrderTotalContainer type="bodyHeavy" />
                  <RescheduleOrderSubmitContainer />
                </Stack>
              </Stack>
            </>
          </RouteReschedule>
        </Stack>
      </Stack>
    </Basket>
  );
};

export default AppointmentBasket;
